import {
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  GET_CART_FAILURE,
  SET_VOUCHER_CODE,
  POST_VOUCHER_CODE_FAILURE,
} from "../../constants";

import { createAction, createErrorAction } from "../../utils";

import showError from "../showError/showError";

// Cart
const getCartRequest = createAction(GET_CART_REQUEST);
const getCartSuccess = createAction(GET_CART_SUCCESS);
const getCartFailure = createErrorAction(GET_CART_FAILURE);

// Voucher code
const postVoucherCodeSuccess = createAction(SET_VOUCHER_CODE);
const postVoucherCodeFailure = createErrorAction(POST_VOUCHER_CODE_FAILURE);

export const postVoucherCode = (voucherCode) => {
  return async (dispatch, getState, { api }) => {
    let getCart = false;

    // Select the package on the backend
    await api.postVoucherCode(voucherCode).then(
      (data) => {
        // Load requests
        dispatch(getCartRequest());
        dispatch(postVoucherCodeSuccess(voucherCode));
        getCart = true;
        window.sessionStorage.setItem("voucherCode", voucherCode);
      },
      (err) => {
        dispatch(postVoucherCodeFailure(err));
      },
    );

    // Get the updated cart
    if (getCart) {
      await api.getCart().then(
        (data) => {
          dispatch(getCartSuccess(data));
          window.GTM && window.GTM.pushCartContents(data);
        },
        (err) => {
          dispatch(showError("cartUpdateFailed"));
          dispatch(getCartFailure(err));
        },
      );
    }
  };
};
